const { REACT_APP_DEFAULT_LANGUAGE, REACT_APP_AVAILABLE_LANGUAGES } =
  process.env

const defaultLanguage = REACT_APP_DEFAULT_LANGUAGE
let availableLanguages = [REACT_APP_DEFAULT_LANGUAGE]

if (REACT_APP_AVAILABLE_LANGUAGES) {
  availableLanguages = JSON.parse(REACT_APP_AVAILABLE_LANGUAGES)
}

export const DEFAULT_LANGUAGE = defaultLanguage
export const AVAILABLE_LANGUAGES = availableLanguages
export const LANGUAGES = ['es', 'vai', 'ca', 'gl', 'eu', 'en', 'de']
